import * as React from 'react';

import { PrimaryCardMessagingModel } from 'models/common';
import { Theme } from 'constants/theme';

import { classNames } from 'uitk-react-utils';

export interface MessagingProps {
  className: string;
  // Experiment PWA_Increase_Prominence_of_Pay_Later_Message needs the following two props
  primaryMessagingList?: PrimaryCardMessagingModel[];
  primaryMessaging?: PrimaryCardMessagingModel; // FIX ME: Remove this model after we roll out wave 7
}

export const Messaging: React.FunctionComponent<MessagingProps> = ({ className, primaryMessaging, primaryMessagingList }) => {
  let messages = [];
  if (primaryMessagingList) {
    messages = primaryMessagingList;
  } else if (primaryMessaging) {
    messages.push(primaryMessaging);
  }

  const messagesToDisplay = messages.map(message => {
    const messageDescription = message && message.description;
    const messageType = message && message.type;
    const messageTheme = message && message.theme;
    const primaryTheme = messageTheme && Theme[messageTheme];
    const classes = classNames('uitk-cell pwa-theme--grey-700', {
      [`${primaryTheme}`]: primaryTheme
    });

    return (
      <div key={`listing-message-${messageType}`} className={classes}>
        {messageDescription || ''}
      </div>
    );
  });

  return messagesToDisplay.length ? (
    <div className={className} data-stid="content-hotel-primary-messaging">
      {messagesToDisplay}
    </div>
  ) : null;
};

Messaging['displayName'] = 'Messaging';
